﻿import { useSKUDetails } from 'pages/sku_management/context';
import { FormattedMessage } from 'react-intl';

export const SKUDetails = () => {

    const { pageContext } = useSKUDetails();

    const sku = pageContext?.Data.skuDetails;

    if (!sku) return null;

    return (
        <div className="mb-3">
            <div className="mt-2">
                <strong>
                    <FormattedMessage defaultMessage="Name" id="name.5458f379" />
                </strong>
                <br />
                {sku.Name}
            </div>

            {sku.AdditionalIdentifier && (
                <div className="mt-2">
                    <strong>
                        <FormattedMessage defaultMessage="Additional Identifier" id="additional_identifier.74c49804" />
                    </strong>
                    <br />
                    {sku.AdditionalIdentifier}
                </div>
            )}

            {/* {sku.Description && (
                <div className="mt-2">
                    <strong>
                        <FormattedMessage defaultMessage="Description" id="description.6317db73" />
                    </strong>
                    <br />
                    {sku.Description}
                </div>
            )} */}

            {sku.CreatedDateString && (
                <div className="mt-2">
                    <strong>
                        <FormattedMessage defaultMessage="Date Created" id="date_created.85efe6f3" />
                    </strong>
                    <br />
                    {sku.CreatedDateString}
                </div>
            )}

            {sku.CreatedBy && (
                <div className="mt-2">
                    <strong>
                        <FormattedMessage defaultMessage="Created By" id="created_by.a458757d" />
                    </strong>
                    <br />
                    {sku.CreatedBy}
                </div>
            )}
        </div>
    );

};
